var _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGold(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_368_12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 8C4 3.58172 7.58172 0 12 0H60C64.4183 0 68 3.58172 68 8V56C68 60.4183 64.4183 64 60 64H12C7.58172 64 4 60.4183 4 56V8Z",
    fill: "url(#paint0_linear_368_12)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_368_12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.4872 21.8709L8 20.9238C8 20.9238 9.66559 35.4559 15.3792 37.9487C21.0928 40.4414 28.4931 43.6526 28.4931 43.6526L24.4872 21.8709Z",
    fill: "url(#paint1_linear_368_12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4284 22.9595L8.46387 21.7729C8.46387 21.7729 9.96079 34.5742 15.0946 37.2521C20.1441 39.8972 28.3983 42.9125 28.3983 42.9125L27.4284 22.9595Z",
    fill: "url(#paint2_linear_368_12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7331 21.3591L65.2204 20.4121C65.2204 20.4121 63.5548 34.9442 57.8412 37.4369C52.1276 39.9297 44.7273 43.1409 44.7273 43.1409L48.7331 21.3591Z",
    fill: "url(#paint3_linear_368_12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.7815 22.4477L64.746 21.2612C64.746 21.2612 63.2491 34.0625 58.1153 36.7403C53.0658 39.3855 44.8116 42.4008 44.8116 42.4008L45.7815 22.4477Z",
    fill: "url(#paint4_linear_368_12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.3534 45.2527L38.2864 55.4306C37.2111 56.0729 35.8723 56.0729 34.7971 55.4306L17.7195 45.2527C16.6442 44.6105 15.9801 43.424 15.9801 42.1286V21.7728C15.9801 20.4883 16.6442 19.2909 17.7195 18.6487L34.7865 8.48168C35.8618 7.83944 37.2006 7.83944 38.2758 8.48168L55.3429 18.6596C56.4181 19.3018 57.0823 20.4883 57.0823 21.7837V42.1395C57.0928 43.424 56.4287 44.6105 55.3534 45.2527Z",
    fill: "#FEEBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.4363 43.8159L37.7382 53.5801C36.9897 54.0156 36.062 54.0156 35.3136 53.5801L18.6155 43.8159C17.9408 43.424 17.5192 42.6838 17.5192 41.9V22.23C17.5192 21.4354 17.9408 20.7061 18.6155 20.3142L35.3136 10.55C36.062 10.1145 36.9897 10.1145 37.7382 10.55L54.4363 20.3142C55.1109 20.7061 55.5326 21.4463 55.5326 22.23V41.8892C55.5326 42.6838 55.1215 43.4131 54.4363 43.8159Z",
    fill: "#FFF1AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6734 56.0076C35.9776 56.0076 35.2819 55.8226 34.6599 55.4525L18.0462 45.5576C16.8023 44.8174 16.0327 43.4349 16.0327 41.9545V22.1757C16.0327 20.6952 16.8023 19.3128 18.0462 18.5726L34.6599 8.67772C35.9038 7.93751 37.4429 7.93751 38.6763 8.67772L55.2901 18.5726C56.534 19.3128 57.3035 20.6952 57.3035 22.1757V41.9654C57.3035 43.4458 56.534 44.8283 55.2901 45.5685L38.6763 55.4634C38.0649 55.8226 37.3691 56.0076 36.6734 56.0076ZM36.6734 10.5174C36.3782 10.5174 36.0831 10.5936 35.8195 10.7568L19.2058 20.6517C18.6787 20.9674 18.3519 21.5443 18.3519 22.1757V41.9654C18.3519 42.5968 18.6787 43.1737 19.2058 43.4894L35.8195 53.3842C36.3466 53.6999 37.0002 53.6999 37.5273 53.3842L54.141 43.4894C54.6681 43.1737 54.9949 42.5968 54.9949 41.9654V22.1757C54.9949 21.5443 54.6681 20.9674 54.141 20.6517L37.5273 10.7568C37.2637 10.5936 36.9686 10.5174 36.6734 10.5174Z",
    fill: "url(#paint5_linear_368_12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.3926 43.0211L37.6854 52.1976C37.0529 52.5677 36.2729 52.5677 35.6403 52.1976L19.9332 43.0211C19.3007 42.651 18.9106 41.9653 18.9106 41.225V22.8722C18.9106 22.132 19.3007 21.4462 19.9332 21.0761L35.6403 11.8996C36.2729 11.5295 37.0529 11.5295 37.6854 11.8996L53.3926 21.0761C54.0251 21.4462 54.4151 22.132 54.4151 22.8722V41.225C54.4151 41.9653 54.0251 42.651 53.3926 43.0211Z",
    fill: "#FEEBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.498 42.8362L37.1056 52.6113C36.8421 52.7637 36.5258 52.7637 36.2623 52.6113L19.8699 42.8362C19.6064 42.6838 19.4482 42.3899 19.4482 42.0851V22.5348C19.4482 22.2191 19.6064 21.9361 19.8699 21.7837L36.2623 12.0086C36.5258 11.8562 36.8421 11.8562 37.1056 12.0086L53.498 21.7837C53.7615 21.9361 53.9197 22.23 53.9197 22.5348V42.0851C53.9197 42.3899 53.7615 42.6838 53.498 42.8362Z",
    fill: "url(#paint6_linear_368_12)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.29
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.6945 52.4589L19.9965 42.4007V22.3062L36.6945 12.248L53.3926 22.3062V42.4007L36.6945 52.4589ZM21.6726 41.4102L36.684 50.4451L51.6954 41.4102V23.3077L36.684 14.2727L21.6726 23.3077V41.4102Z",
    fill: "url(#paint7_linear_368_12)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M36.6418 53.5256C36.4415 53.5256 36.2412 53.4712 36.0726 53.3624L19.2375 43.2498C18.8896 43.043 18.6682 42.6511 18.6682 42.2265V21.9905C18.6682 21.5769 18.8896 21.185 19.2375 20.9673L36.0726 10.8547C36.431 10.637 36.8632 10.637 37.2216 10.8547L54.0567 20.9673C54.4046 21.1741 54.626 21.566 54.626 21.9905V42.2265C54.626 42.6402 54.4046 43.0321 54.0567 43.2498L37.2216 53.3624C37.0424 53.4712 36.8421 53.5256 36.6418 53.5256ZM20.5657 41.7802L36.6418 51.4356L52.7179 41.7802V22.4477L36.6418 12.7814L20.5657 22.4368V41.7802Z",
    fill: "url(#paint8_linear_368_12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9053 30.4376C36.8842 30.2961 36.9475 19.1494 36.9475 19.1494L32.5305 25.8766L36.9053 30.4376Z",
    fill: "url(#paint9_linear_368_12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9476 19.1494L41.2064 25.844L36.9054 30.4376L36.9476 19.1494Z",
    fill: "url(#paint10_linear_368_12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1958 25.833L48.1322 27.7053L36.8948 30.4267L41.1958 25.833Z",
    fill: "url(#paint11_linear_368_12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1429 27.7163L43.4623 34.0408L36.9054 30.4377L48.1429 27.7163Z",
    fill: "url(#paint12_linear_368_12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5938 25.833L25.6573 27.7053L36.9054 30.4267L32.5938 25.833Z",
    fill: "url(#paint13_linear_368_12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6573 27.7056L30.3379 34.03L36.9054 30.4269L25.6573 27.7056Z",
    fill: "url(#paint14_linear_368_12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3379 34.0298L30.0638 41.4319L36.9054 30.4268L30.3379 34.0298Z",
    fill: "url(#paint15_linear_368_12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8948 30.4377L36.7999 38.7651L30.0532 41.4538L36.8948 30.4377Z",
    fill: "url(#paint16_linear_368_12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.515 34.0735L43.6099 41.4974L36.8843 30.416L43.515 34.0735Z",
    fill: "url(#paint17_linear_368_12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8948 30.4268L36.9053 38.7541L43.6204 41.519L36.8948 30.4268Z",
    fill: "url(#paint18_linear_368_12)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_368_12",
    x: 0,
    y: 0,
    width: 72,
    height: 72,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_368_12"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_368_12",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_368_12",
    x: 4,
    y: 8,
    width: 65.2203,
    height: 56.0076,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_368_12"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_368_12",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_368_12",
    x1: 36,
    y1: 0,
    x2: 36,
    y2: 64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBAA39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF3B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_368_12",
    x1: 15.3254,
    y1: 19.0506,
    x2: 29.9588,
    y2: 65.0267,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1329,
    stopColor: "#FED76E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4209,
    stopColor: "#D1994E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.556,
    stopColor: "#D86F2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_368_12",
    x1: 17.7689,
    y1: 21.4318,
    x2: 10.1251,
    y2: 68.4413,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED97A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2516,
    stopColor: "#EBA04C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4498,
    stopColor: "#EEB332"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_368_12",
    x1: 57.8872,
    y1: 18.5382,
    x2: 43.2538,
    y2: 64.5143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1329,
    stopColor: "#FED76E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4209,
    stopColor: "#D1994E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.556,
    stopColor: "#D86F2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_368_12",
    x1: 55.4437,
    y1: 20.9194,
    x2: 63.0876,
    y2: 67.9288,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED97A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.317,
    stopColor: "#EBA04C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5771,
    stopColor: "#EEB332"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_368_12",
    x1: 26.3568,
    y1: 13.6196,
    x2: 47.9941,
    y2: 49.9131,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCE881"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3128,
    stopColor: "#FED65B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6369,
    stopColor: "#FCC552"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8C043"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_368_12",
    x1: 34.8529,
    y1: 16.8789,
    x2: 39.3395,
    y2: 52.292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEDB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2658,
    stopColor: "#FEDF6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6225,
    stopColor: "#FDC727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9268,
    stopColor: "#F39D50"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_368_12",
    x1: 19.9906,
    y1: 32.3596,
    x2: 53.3967,
    y2: 32.3596,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC961"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE98B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_368_12",
    x1: 27.5922,
    y1: 15.9169,
    x2: 46.5868,
    y2: 47.7775,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0B335"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2291,
    stopColor: "#EEB854"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4497,
    stopColor: "#EFB550"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7961,
    stopColor: "#FFD06C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBEBBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_368_12",
    x1: 33.8821,
    y1: 20.9791,
    x2: 38.834,
    y2: 29.2853,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2682,
    stopColor: "#FFDB63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3943,
    stopColor: "#FFE176"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6467,
    stopColor: "#FFEB97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8577,
    stopColor: "#FFF1AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF3B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_368_12",
    x1: 34.7575,
    y1: 20.4548,
    x2: 39.7094,
    y2: 28.7609,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2682,
    stopColor: "#F9D35A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4563,
    stopColor: "#F4C64B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7806,
    stopColor: "#EDB537"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAAF30"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_368_12",
    x1: 42.767,
    y1: 25.1627,
    x2: 42.0377,
    y2: 35.7169,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4BC46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1296,
    stopColor: "#F6C350"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4861,
    stopColor: "#FBD267"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7095,
    stopColor: "#FDD870"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726,
    stopColor: "#FDDA76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8271,
    stopColor: "#FEE897"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9116,
    stopColor: "#FFF0AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9687,
    stopColor: "#FFF3B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_368_12",
    x1: 45.9589,
    y1: 30.4662,
    x2: 40.2676,
    y2: 32.1004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9994A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1549,
    stopColor: "#EC9C47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7095,
    stopColor: "#F5A43F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#F4A63F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEAD3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_368_12",
    x1: 29.2367,
    y1: 26.8154,
    x2: 36.075,
    y2: 29.6076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE0A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00757147,
    stopColor: "#FFDFA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2649,
    stopColor: "#F7CE7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4717,
    stopColor: "#F2C363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601,
    stopColor: "#F0BF5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6705,
    stopColor: "#F2BC51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867,
    stopColor: "#F6B63D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7B436"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_368_12",
    x1: 27.8438,
    y1: 30.4583,
    x2: 33.5351,
    y2: 32.0925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1A426"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0259542,
    stopColor: "#F1A426"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7095,
    stopColor: "#F3A81D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2A41C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_368_12",
    x1: 31.0051,
    y1: 34.4518,
    x2: 35.3249,
    y2: 36.8686,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1A31A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2356,
    stopColor: "#EAB639"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.567,
    stopColor: "#F6CE5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8335,
    stopColor: "#FCDD76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE27F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_368_12",
    x1: 33.0216,
    y1: 35.5655,
    x2: 38.4601,
    y2: 39.846,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E19318"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4611,
    stopColor: "#D97F21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D16B29"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_368_12",
    x1: 42.81,
    y1: 34.4662,
    x2: 38.361,
    y2: 36.8965,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7CD43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5411,
    stopColor: "#FACA53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBC85C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_368_12",
    x1: 40.7152,
    y1: 35.5972,
    x2: 35.2349,
    y2: 39.8207,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDAE3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2646,
    stopColor: "#EDA636"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE9227"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGold);
export default __webpack_public_path__ + "static/media/gold.e7eab67f10b1505d4b08ba278aed24fb.svg";
export { ForwardRef as ReactComponent };